import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { DeliveryType } from 'src/api/@generated/backend-api';

import { OrderState, OrderStep, ProductDetailsPage } from './types';

const initialState: OrderState = {
  reachedStep: OrderStep.CHOOSE_ACCOUNT,
  selectedDeliveryType: 'HELTHJEM_TO_DOOR',
};

const orderSlice = createSlice({
  name: 'order',
  initialState,
  reducers: {
    setReachedStep: (state, action: PayloadAction<OrderStep>) => {
      state.reachedStep = action.payload;
    },
    setLastVisitedProductDetailsPage: (state, action: PayloadAction<ProductDetailsPage>) => {
      state.lastVisitedProductDetailsPage = action.payload;
    },
    setDeliveryType: (state, action: PayloadAction<DeliveryType>) => {
      state.selectedDeliveryType = action.payload;
    },
    resetOrderState: () => initialState,
  },
});

export const {
  actions: { setReachedStep, setLastVisitedProductDetailsPage, setDeliveryType, resetOrderState },
  reducer: orderSliceReducer,
} = orderSlice;
